module.exports = __webpack_public_path__ + "static/wireframe@2x-37753ad9da18a08e9ce47b1d68ad06a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/wireframing/wireframe@2x.png
// module id = 2628
// module chunks = 168707334958949